import { Button } from "@babackapp/ui/components/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@babackapp/ui/components/sheet";
import { Editor } from "@monaco-editor/react";
import { CodeIcon, SaveIcon, SmileIcon } from "lucide-react";
import { useState } from "react";
import { useWorkflowForm } from "../context/workflows-editor-workflows-context";


export function WorkflowCodeEditorSheet() {
  const form = useWorkflowForm();
  const workflow = form.watch("workflow");
  const [codeValue, setCodeValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (open && workflow) {
      // Load current workflow data when opening
      setCodeValue(JSON.stringify(workflow, null, 2));
    }
  };

  const prettifyCode = () => {
    try {
      const parsed = JSON.parse(codeValue);
      setCodeValue(JSON.stringify(parsed, null, 2));
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  };

  const saveCode = () => {
    try {
      const parsed = JSON.parse(codeValue);
      form.setValue("workflow", parsed, { shouldDirty: true });
      setIsOpen(false);
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  };

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetTrigger asChild>
        <Button
          size="icon"
          variant="secondary"
          className="fixed bottom-4 right-4 z-50 shadow-lg"
        >
          <CodeIcon className="size-4" />
        </Button>
      </SheetTrigger>
      <SheetContent className="w-full sm:max-w-5xl overflow-hidden flex flex-col">
        <SheetHeader>
          <SheetTitle>Workflow JSON Editor</SheetTitle>
          <SheetDescription>
            Edit the workflow JSON directly. Changes will be applied when you
            save.
          </SheetDescription>
        </SheetHeader>
        <div className="flex-1 relative min-h-0 border rounded-xl overflow-hidden bg-card mt-4">
          <Editor
            language="json"
            value={codeValue}
            theme="vs-dark"
            onChange={(e) => setCodeValue(e ?? "")}
            options={{
              minimap: { enabled: false },
              fontSize: 14,
              lineNumbers: "on",
              scrollBeyondLastLine: false,
              automaticLayout: true,
            }}
          />
          <div className="flex gap-2 items-center absolute bottom-4 right-4 z-50">
            <Button size="icon" variant="secondary" onClick={prettifyCode}>
              <SmileIcon className="size-4" />
            </Button>
            <Button size="icon" variant="secondary" onClick={saveCode}>
              <SaveIcon className="size-4" />
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
